/** Punto de entrada de la interfaz. */

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import { App } from './App'
import { iniciarSesion } from './auth/keycloak'
import { ProveedorSesion } from './contexto/Sesion'
import { ProveedorTema } from './contexto/Tema'
import './i18n'

const raiz = document.getElementById('raiz')
if (!raiz) throw new Error('No se ha encontrado el elemento #raiz')
const root = createRoot(raiz)

// Con Keycloak, sin sesión corporativa se va al login antes de pintar nada; en
// modo local, `iniciarSesion` no hace nada. Si el servidor de identidad aún no
// responde (p. ej. en local, Keycloak todavía arrancando), se dice claramente y
// se reintenta solo cada pocos segundos, en vez de dejar la pantalla bloqueada.
const REINTENTO_MS = 5000

function pintarAplicacion() {
  root.render(
    <StrictMode>
      <BrowserRouter>
        <ProveedorTema>
          <ProveedorSesion>
            <App />
          </ProveedorSesion>
        </ProveedorTema>
      </BrowserRouter>
    </StrictMode>,
  )
}

function pintarSinAcceso() {
  root.render(
    <div style={{ padding: 32, fontFamily: 'sans-serif', maxWidth: 640 }}>
      <p>
        No se puede conectar con el acceso corporativo (Keycloak). Se reintenta automáticamente; si
        no se resuelve, avise a IT.
      </p>
      <button type="button" onClick={() => window.location.reload()}>
        Reintentar ahora
      </button>
    </div>,
  )
}

function arrancar() {
  iniciarSesion()
    .then(pintarAplicacion)
    .catch(() => {
      pintarSinAcceso()
      window.setTimeout(() => window.location.reload(), REINTENTO_MS)
    })
}

arrancar()
